import React from "react";

function LoadingIndicator(props) {
  if (props.loading === true) {
    return (
      <div className="row">
        <div className="col-md-12">
          <p className="text-center">loading...</p>
        </div>
      </div>
    );
  }

  return null;
}

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/loading/LoadingIndicator.js